import { motion } from "framer-motion";

/**
 * Reveal — drop-in scroll-fade-up wrapper.
 * Default: 24px slide + opacity fade, easeOut, only fires once.
 * Use `delay` to offset within a sequence; `y` to override slide distance.
 */
export default function Reveal({
  children,
  className = "",
  delay = 0,
  y = 24,
  duration = 0.65,
  margin = "-80px",
  testid,
}) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration, ease: "easeOut", delay }}
      viewport={{ once: true, margin }}
      className={className}
      data-testid={testid}
    >
      {children}
    </motion.div>
  );
}
